import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bookPackageKeys, MODE } from '../../../data/queryFactories'
import BookPackageFormModal from './BookPackageFormModal'
import { bookCollectionService } from '../../../service/BookCollectionService'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from '../../../utils/showToast'
import { useModal } from '../../../context/ModalProvider'

export default function EditBookPackageModal({ uuid, name }) {
  const queryClient = useQueryClient()
  const { handleCloseModal } = useModal()
  const editBookPackageMutation = useMutation({
    mutationFn: async (bookPackage) => {
      const dataBookPackage = await bookCollectionService.getAll()
      const arrayBookPackage = dataBookPackage.message.content
      if (
        arrayBookPackage.find(
          (item) => item.name === bookPackage.name && item.uuid !== uuid
        )
      ) {
        throw new Error('Tên gói sách đã tồn tại! Vui lòng chọn tên khác.')
      }
      const { success, message } = await bookCollectionService.update({
        name: bookPackage.name,
        uuid: uuid,
      })
      if (!success) {
        throw new Error(message.content)
      }
      return { success, message }
    },
    onMutate: () => {
      showLoadingToast('Đang cập nhật gói sách', bookPackageKeys.all)
    },
    onError: (error) => {
      showErrorToast({
        message: error.message || 'Cập nhật gói sách thất bại',
        toastId: bookPackageKeys.all,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bookPackageKeys.all })
      showSuccessToast('Cập nhật gói sách thành công', bookPackageKeys.all)
      handleCloseModal()
    },
  })

  return (
    <BookPackageFormModal
      mode={MODE.EDIT}
      initForm={{
        name: name ?? '',
      }}
      submitHandler={(formData) => {
        editBookPackageMutation.mutate(formData)
      }}
      isLoading={editBookPackageMutation.isPending}
    />
  )
}
